// src/pages/AdminPage.js
import React, { useState } from 'react';
import AdminUsuarios from '../components/admin/AdminUsuarios';
import AdminInvitaciones from '../components/admin/AdminInvitaciones';
import AdminConfiguracion from '../components/admin/AdminConfiguracion';
import AdminLimites from '../components/admin/AdminLimites';
import AdminFeedback from '../components/admin/AdminFeedback';
import AdminKrumsConfig from '../components/admin/AdminKrumsConfig';
import AdminStatsPage from './AdminStatsPage'; // ← AGREGAR ESTA LÍNEA
import AdminFinanzasPage from './AdminFinanzasPage';
//import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//import { faUsers, faEnvelope, faScaleBalanced, faGear, faChartPie } from '@fortawesome/free-solid-svg-icons';


const AdminPage = () => {
  const [seccionActiva, setSeccionActiva] = useState('dashboard');

 /*const menuItems = [
  { id: 'dashboard', nombre: 'Dashboard', icono: faChartPie }, // Cambiado faDashboard no existe
  { id: 'usuarios', nombre: 'Usuarios', icono: faUsers },
  { id: 'invitaciones', nombre: 'Invitaciones Beta', icono: faEnvelope },
  { id: 'limites', nombre: 'LÃƒÂ­mites Beta', icono: faScaleBalanced },
  { id: 'configuracion', nombre: 'ConfiguraciÃƒÂ³n', icono: faGear },
];*/

	const menuItems = [
	  { id: 'dashboard', nombre: 'Dashboard', icono: '📊' },
	  { id: 'usuarios', nombre: 'Usuarios', icono: '👥' },
	  { id: 'invitaciones', nombre: 'Invitaciones Beta', icono: '📨' },
	  { id: 'limites', nombre: 'Límites Beta', icono: '⚖️' },
	  { id: 'feedback', nombre: 'Feedback Beta', icono: '📢' },
	  { id: 'krums-admin', nombre: 'Configuración Krums', icono: '💰' }, // ← Esta línea
	  { id: 'stats', nombre: 'Estadísticas', icono: '📊' },
	  { id: 'configuracion', nombre: 'Configuración', icono: '⚙️' },
	  { id: 'finanzas', nombre: 'Finanzas', icono: '💰' },
	];

		
  const renderSeccion = () => {
    switch(seccionActiva) {
      case 'usuarios':
        return <AdminUsuarios />;
      case 'invitaciones':
        return <AdminInvitaciones />;
      case 'limites':
        return <AdminLimites />;
      case 'configuracion':
        return <AdminConfiguracion />;
	  case 'feedback':
  		return <AdminFeedback />;
	  case 'stats':
  		return <AdminStatsPage />;
	  case 'krums-admin':
  		return <AdminKrumsConfig />;
	  case 'finanzas':
  		return <AdminFinanzasPage />;
      default:
        return (
          <div className="admin-dashboard">
            <h2>Panel de Administraci&oacute;n</h2>
            <p>Bienvenido al panel de control de KREAMUN</p>
            <div className="dashboard-stats">
              {/* AquÃƒÂ­ irÃƒÂ­an estadÃƒÂ­sticas */}
            </div>
          </div>
        );
    }
  };
	
	
  return (
    <div className="admin-layout">
      <div className="admin-sidebar">
        <div className="sidebar-header">
          <h3>KREAMUN Admin</h3>
        </div>
        <nav className="sidebar-nav">
          {menuItems.map(item => (
            <button
              key={item.id}
              className={`sidebar-item ${seccionActiva === item.id ? 'active' : ''}`}
              onClick={() => setSeccionActiva(item.id)}
            >
              <span className="sidebar-icon">{item.icono}</span>
              <span className="sidebar-text">{item.nombre}</span>
            </button>
          ))}
        </nav>
      </div>
      <div className="admin-content">
        {renderSeccion()}
      </div>
    </div>
  );
};

export default AdminPage;